import { usePermissions } from 'common/usePermissions';
import HeaderItems from 'components/Header/HeaderItems';
import { useCustomTranslation } from 'helpers/translationHelper';
import React from 'react';

export const useAdminNavigationItems = () => {
  const { t } = useCustomTranslation();

  const { can } = usePermissions();

  const items = [
    {
      to: '/',
      label: t('mainMenu.dashboard'),
      exact: true
    },
    {
      to: '/admin/companies',
      label: t('mainMenu.companies')
    },
    {
      to: '/admin/leads',
      label: t('mainMenu.leads'),
      hidden: !can(['Superadmin_Leads_Manage'])
    },
    {
      to: '/admin/logs',
      label: t('mainMenu.logs'),
      hidden: !can(['Superadmin_Statistics_Read'])
    },
    {
      to: '/admin/templates',
      label: t('mainMenu.templates'),
      hidden: !can(['Superadmin_CompanyTemplates_Manage'])
    },
    {
      to: '/admin/featureflags',
      label: t('mainMenu.featureFlags'),
      hidden: !can(['Superadmin_FeatureFlags_Manage'])
    },
    {
      to: '/admin/announcements',
      label: t('mainMenu.announcements'),
      hidden: !can(['Superadmin_Announcements_Manage'])
    },
    {
      to: '/admin/supportTickets',
      label: t('mainMenu.supportTickets'),
      hidden: !can(['Superadmin_CustomerSupport_ReadAll', 'Superadmin_CustomerSupport_Read'])
    },
    {
      to: '/admin/users',
      label: t('mainMenu.users'),
      hidden: !can(['Superadmin_SuperadminUsers_Manage'])
    },
    {
      to: '/admin/customerUsers',
      label: t('mainMenu.customerUsers'),
      hidden: !can(['Superadmin_CustomerUsers_ReadAll'])
    },
    {
      to: '/admin/subscriptions',
      label: t('mainMenu.subscriptions'),
      hidden: !can(['Superadmin_Subscriptions_ManageDefinitions'])
    }
  ];

  return items;
};

const AdminHeader = () => {
  const items = useAdminNavigationItems();
  return <HeaderItems items={items} />;
};

export default AdminHeader;
